document.addEventListener('DOMContentLoaded', function() {
    var el = document.getElementById('langSelectorArea');
    if (el) {
        document.addEventListener('click', function(event) {
            var isClickInside = el.contains(event.target);
            if (!isClickInside && (document.querySelector('#langSelector').classList.contains('in') || document.querySelector('#langSelector').classList.contains('show'))) {
                document.querySelector('[data-target="#langSelector"]').click();
            }
        });
    }
});